<template>
  <div class="footerComponent" >
    <footer>
      <div class="footer-container">
        <div class="col-md-4 col-12 footer-col">
          <ul class="menu-footer">
            <li> <router-link to='/'> Accueil </router-link> </li>
          </ul>
        </div>
        <div class="col-md-4 col-12 footer-col">
          <ul class="menu-footer">
            <li> <a href="mailto:contact@audaspro.org"> Nous contacter  </a> </li>
          </ul>
        </div>
        <div class="col-md-4 col-12  footer-col">
          <ul class="menu-footer">
            <li> <router-link to='/mentions-legales'> Mentions légales & Politique de confidentialité </router-link> </li>
          </ul>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'footerComponent',
}
</script>

<style>
/* --------------------- FOOTER ------------------*/

footer{
  color: #d6075b;
  flex-shrink: 0;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
  padding: 2px;
}

footer .footer-container {
  background-color: #FBEFF2;
  padding: 20px 30px;
  text-align: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  align-content: center;
}

footer .footer-container .row {
  width: 100%;
}

.footer-right-border {
  border-bottom: 1px solid #d6075b !important;
}

.footer-col {
  padding: 15px 10px;
}

footer .footer-bottom * {
    padding: 0;
}

footer .footer-container-background-top {
    height: 500px;
    position: absolute;
    width: 100%;
    background-color: #fff !important;
    z-index: 1;
    margin-top: -1000px;
}

footer .menu-footer {
    list-style-type: none;
    padding-left: 0;
    font-size: 20px;
    display: grid;
    height: 100%;
    margin-top: 0px;
    margin-bottom: 0px;
}

footer .menu-footer a {
  color: #d6075b;
  text-decoration: none;
}

footer .menu-footer a:hover {
  font-weight: bold;
}

@media (min-width: 768px) {
  .footer-right-border {
    border-bottom: none !important;
    border-right: 1px solid #d6075b;
  }
}

</style>
